import React, { useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useMediaQuery } from 'react-responsive';
import { AnimatePresence } from 'framer-motion';
import {
  AnimationTransitions,
  SideNavBodyContainerStyled,
  SideNavBodyContentContainerStyled,
} from './styles/SideNavMobileStyled';
import Menu from '../Menu';
import AppContext from '../../App/AppContext';

const SideNavMobile = () => {
  const { showMenuMobile, setShowMenuMobile } = useContext(AppContext);

  const close = () => setShowMenuMobile(false);
  const isMobileDevice = useMediaQuery({ maxWidth: 768 });
  const portalRoot = document?.body ?? null;

  useEffect(() => {
    if (typeof document !== 'undefined') {
      if (showMenuMobile) {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.overflow = 'auto';
        document.body.style.position = 'initial';
        document.body.style.width = 'auto';
      }
    }
  }, [showMenuMobile]);

  useEffect(() => {
    if (!isMobileDevice) close();
  }, [isMobileDevice]);

  const Content = (
    <AnimatePresence>
      {showMenuMobile && isMobileDevice && (
        <SideNavBodyContainerStyled>
          <SideNavBodyContentContainerStyled
            variants={AnimationTransitions}
            initial="initial"
            animate="enter"
            exit="exit"
          >
            <Menu />
          </SideNavBodyContentContainerStyled>
        </SideNavBodyContainerStyled>
      )}
    </AnimatePresence>
  );

  if (typeof window !== 'undefined') {
    return <>{createPortal(Content, portalRoot)}</>;
  }
  return null;
};

export default SideNavMobile;
